var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 769"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "quote-stars_svg__a",
    d: "M.07.332h1.45v1.5H.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "quote-stars_svg__c",
    d: "M.33 0h1.45v2H.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "quote-stars_svg__e",
    d: "M.342.17h1.45v1.5H.342z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.397
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 35.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M25.5 486.375c.666 0 .667-1 0-1-.666 0-.667 1 0 1M115 562.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M101 549.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M.5 284.375c.666 0 .667-1 0-1-.666 0-.667 1 0 1",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288 .375)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "quote-stars_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#quote-stars_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.795 1.831c.965 0 .967-1.5 0-1.5-.965 0-.967 1.5 0 1.5",
    fill: "#FFF",
    mask: "url(#quote-stars_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234 43.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M301 678.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M427 521.375c1.332 0 1.335-2 0-2-1.332 0-1.334 2 0 2M135 425.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M563 43.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M473 40.375c1.332 0 1.335-2 0-2-1.332 0-1.334 2 0 2M483 562.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M550 721.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M437 299.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M38 671.375c1.332 0 1.335-2 0-2-1.332 0-1.334 2 0 2M421 632.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M492 643.375c1.332 0 1.335-2 0-2-1.332 0-1.334 2 0 2M286 15.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M16.5 16.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M544.5 57.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M315 135.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M301.5 122.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M165.5 682.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M389 103.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M410.5 618.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M199 141.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M180.5 115.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M174.5 153.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M219.5 633.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M355.5 693.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M250.5 724.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M500.5 378.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M492 291.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314 766.375)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "quote-stars_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#quote-stars_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.055 2c.966 0 .967-2 0-2-.965 0-.967 2 0 2",
    fill: "#FFF",
    mask: "url(#quote-stars_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281 262.375c1.332 0 1.335-2 0-2-1.332 0-1.334 2 0 2M183 549.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M550 175.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M166 299.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M371 391.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M315 208.375c1.332 0 1.335-2 0-2-1.332 0-1.334 2 0 2M451 222.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M473 141.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M473 166.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M457 156.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M484 456.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M251 584.375c1.332 0 1.335-2 0-2-1.332 0-1.334 2 0 2M286 519.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M525 383.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M165 235.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M319 610.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M371 274.375c1.332 0 1.335-2 0-2-1.332 0-1.334 2 0 2",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(598 317.375)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "quote-stars_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#quote-stars_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.067 1.67c.965 0 .967-1.5 0-1.5-.965 0-.967 1.5 0 1.5",
    fill: "#FFF",
    mask: "url(#quote-stars_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251 397.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M175 472.375c1.332 0 1.334-2 0-2-1.332 0-1.334 2 0 2M234 306.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M280.5 455.375c.666 0 .667-1 0-1-.666 0-.667 1 0 1M319 352.375c1.332 0 1.334-2 0-2-1.332 0-1.335 2 0 2M426.5 277.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M419.5 464.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6M546.5 536.375c3.33 0 3.336-6 0-6-3.33 0-3.336 6 0 6",
    fill: "#FFF"
  }))));
}

export default __webpack_public_path__ + "static/quote-stars.51f78e4c.svg";
export { SvgQuoteStars as ReactComponent };